import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import renderHTML from "react-render-html";
import { navigate } from "gatsby";

// core components
import GridContainer from "components/uikit/Grid/GridContainer.js";
import GridItem from "components/uikit/Grid/GridItem.js";
// import Button from "components/uikit/CustomButtons/Button.js";
import Parallax from "components/uikit/Parallax/Parallax.js";
import styles from "assets/jss/material-kit-react/views/mainPage.js";
// Sections for this page
import ProductSection from "./Sections/HtmlSection.js";
import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { listShowMains } from "graphql/queries";
import BoothSelect from "components/organisims/BoothSelect";
import MainMap from "components/organisims/MainMap";
import { Button, Dialog } from "@material-ui/core";
import Search from "components/pages/front/Search";
import { ListShowsQuery } from "API.js";

const useStyles = makeStyles(styles);

export default function Main(props) {
  const classes = useStyles();
  const { show } = props;
  const [data, setData] = React.useState();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    async function f() {
      const res = (await API.graphql(
        // @ts-ignore
        graphqlOperation(listShowMains, {
          filter: { showID: { eq: show.showID } },
        })
      )) as GraphQLResult<ListShowsQuery>;
      // console.log("listShowMains:", res.data.listShowMains);
      // @ts-ignore
      setData(res.data.listShowMains.items[0]);
    }
    f();
  }, [show.showID]);

  return (
    <div>
      {show && data && (
        <>
          <Parallax
            filter
            style={{ height: "60vh" }}
            image={data?.backgroundImage ? data?.backgroundImage?.url : null}
          >
            <div className={classes.container}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <h1 className={classes.title}>{renderHTML(data.title)}</h1>
                  {/* {data.discription && (
                    <div className={classes.discription}>
                      {renderHTML(data.discription)}
                    </div>
                  )} */}
                </GridItem>
              </GridContainer>
            </div>
          </Parallax>

          <div className={classNames(classes.main, classes.mainRaised)}>
            <MainMap show={show} />
            {data.search && (
              <div style={{ textAlign: "center", margin: "1rem" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  検索する
                </Button>
                <Dialog
                  fullWidth
                  maxWidth="lg"
                  open={open}
                  onClose={() => setOpen(false)}
                  keepMounted
                >
                  <Search show={show} />
                </Dialog>
              </div>
            )}

            {data.mapDiscription && (
              <div className={classes.mapDiscription}>
                <ProductSection data={data.mapDiscription} />
              </div>
            )}

            <div className={classes.container}>
              <BoothSelect show={show} />
              {data.logoDiscription && (
                <ProductSection data={data.logoDiscription} />
              )}
              <ProductSection data={data.discription} />
              <ProductSection data={data.section} />
              {/* <TeamSection />
          <WorkSection /> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
